<script lang="ts">
  import { emptyStateId } from '@pin/client-state-observable';
  import ArtistCard from '../components/ArtistCard.svelte';
  import Loader from '../components/Loader.svelte';
  import NoContent from '../components/NoContent.svelte';
  import { loginSessionStore } from '../login/loginSessionStore';
  import { clientState } from '../util/stores';
  import Empty from '../views/Empty.svelte';
  import Login from '../views/Login.svelte';

  export let params: { artistId: string };
</script>

{#if $clientState == null}
  <Empty />
{:else if $clientState.id === emptyStateId || $loginSessionStore == null}
  <Loader description="Laster avstemning" />
{:else if !$loginSessionStore.user}
  <Login />
{:else if $clientState.type === 'before' || $clientState.type === 'open' || $clientState.type === 'closing'}
  <ArtistCard state={$clientState} artistId={params.artistId} />
{:else}
  <NoContent />
{/if}
